<template>
  <!-- <el-tooltip effect="dark" :content="tip" placement="top"> -->
  <div v-if="!disabled" class="table-button" @click="onClick">
    <img :src="imgSrc" alt="">
    <span class="tip">{{ tip }}</span>
  </div>
  <!-- </el-tooltip> -->
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    }
  },
  computed: {
    imgSrc() {
      return require(`../../assets/icon/icon-${this.name}.png`)
    }
  },
  methods: {
    onClick() {
      this.$emit('click')
    }
  }
}
</script>

<style lang='scss'>
.table-button{
    display: flex;
    justify-content: center;
    align-items: center;
    &:hover{
      cursor: pointer;
      text-decoration: underline;
    }
    .tip{
      font-size: 12px;
      color: #333;
      margin-left: 4px;
    }
    img{
      object-fit: contain;
      display: inline-block;
      height: 12px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/TableButton/index.vue